import React from 'react'
import { useTranslation } from 'react-i18next'

import { Text } from '../../ui/Typography/Typography'
import { CancelActionModal } from './CancleActionModal'

interface Props {
  onStayConnected: () => void
  onLogout: () => void
  redirectAfter: number
  timer: number
}

export const SessionExpirationModal: React.FC<Props> = ({
  onStayConnected,
  onLogout,
  redirectAfter,
  timer,
}) => {
  const { t } = useTranslation()

  return (
    <CancelActionModal
      title={t('Your Session is About to Expire!')}
      footer={[
        <button className='button' onClick={onLogout} type='button'>
          {t('Log Out')}
        </button>,
        <button className='button' onClick={onStayConnected} type='button'>
          {t('Stay Connected')}
        </button>,
      ]}
    >
      <Text isParagraph>
        {t('Your session will expire in', {
          minutes: redirectAfter / 60 / 1000,
        })}
      </Text>
      <Text isParagraph>{t('Redirecting in', { seconds: Math.round(timer / 1000) })}</Text>
      <div className='pt-4'>
        <progress
          className='progress is-danger is-small'
          value={(timer / 1000 / (redirectAfter / 1000)) * 100}
          max='100'
        />
      </div>
    </CancelActionModal>
  )
}
